import styled from "styled-components";

const FieldLabel = styled.div`
  color: #928fa3;
  height: 24px;
  font-family: Public Sans;
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  cursor: pointer;
  max-width: fit-content;
  &:hover {
    text-decoration: underline;
  }
`;

const FieldValueSection = styled.div`
  font-family: Public Sans;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 24px;
  color: #302e38;
  display: flex;
  align-items: baseline;
`;

const JobCattegoryWrapper = styled.div`
  max-width: 200px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

const FieldValue = styled.div`
  width: 120px;
`;

const DropdownWrapper = styled.div`
  width: 32px;
  height: 32px;
  background-color: #f1f0f5;
  border-radius: 4px;
  display: flex;
  text-align: center;
  align-items: center;
  line-height: 24px;
  position: relative;
  top: 24px;
  left: 700px;
  padding: 10px;
  user-select: none;
  cursor: pointer;
`;

const ChannelCardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
`;

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const AdminReadWrapper = styled.div`
  display: flex;
  align-items: flex-start;
`;

const AdminReadCenter = styled.div`
  width: calc(100% - 350px);
`;

const CompanyNameLabel = styled.p`
  font-size: 18px;
  line-height: 24px;
  font-weight: bold;
  font-family: Public Sans;
  color: #928fa3;
`;

const MainCampaignMetricsWrapper = styled.div`
  min-height: 128px;
  background: white;
  margin-right: 16px;
  display: flex;
  justify-content: space-around;
  align-items: center;
`;

const MainMetric = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MainMetricWrapperLeft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const MainMetricProgress = styled.span`
  font-family: "Public Sans";
  font-size: 24px;
  line-height: 32px;
  font-weight: 700;
  color: #302e38;
`;

const MainMetricGoal = styled.span`
  font-family: "Public Sans";
  font-size: 14px;
  line-height: 24px;
  font-weight: 500;
  color: #928fa3;
  margin-left: 5px;
`;

const MainMetricDescription = styled.p`
  font-family: "Public Sans";
  font-weight: 500;
  font-size: 14px;
  font-weight: 500;
  color: #928fa3;
  margin-top: 4px;
`;

const NavbarWrapper = styled.div`
  position: sticky;
  top: 65px;
  left: 0;
  z-index: 10000000;
  background: #f2f5f7;
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  margin-right: 20px;

  > div:first-child {
    flex: 0 0 auto;
  }

  > div:last-child {
    flex: 1 0 auto;
  }
`;

const AdminOptionsWrapper = styled.div`
  position: absolute;
  top: 20px;
  right: 13px;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;

  > span,
  > button {
    margin-right: 10px;
  }
`;

export {
  FieldLabel,
  FieldValueSection,
  FieldValue,
  ChannelCardContainer,
  ButtonsWrapper,
  MainWrapper,
  AdminReadWrapper,
  AdminReadCenter,
  AdminOptionsWrapper,
  CompanyNameLabel,
  MainCampaignMetricsWrapper,
  MainMetric,
  MainMetricWrapperLeft,
  MainMetricProgress,
  MainMetricGoal,
  MainMetricDescription,
  DropdownWrapper,
  JobCattegoryWrapper,
  NavbarWrapper
};
